/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { createSelector } from '@ngrx/store';
import { selectThreadState } from './feature-selectors';

export const selectThreadEntities = createSelector(selectThreadState, (state) => state.threadEntityState.entities);

const createSelectorById = (threadId: string) => createSelector(selectThreadEntities, (entities) => entities[threadId]);

const selectAll = createSelector(selectThreadEntities, (entities) => Object.values(entities));

const selectShouldLoadThreads = createSelector(
  selectThreadState,
  (state) => !state.areAllLoaded && !state.areAllLoading,
);

export const ThreadSelectors = {
  createSelectorById,
  selectAll: selectAll,
  selectShouldLoadThreads,
};
